module.exports = __webpack_public_path__ + "img/标题1.0cb8a074.png";